import { useState } from 'react'

import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import LinearProgress from '@mui/material/LinearProgress'
import TextField from '@mui/material/TextField'

import { StyledError } from '../../theme/components/StyledError'
import { useResetAanvraag } from '../hooks/useResetAanvraag'

export const AanvraagResetten = () => {
  const [aanvraagID, setAanvraagID] = useState('')
  const {
    mutate: resetAanvraag,
    isPending: isLoading,
    error,
  } = useResetAanvraag()

  const onClick = () => {
    resetAanvraag(
      { aanvraagID },
      {
        onSuccess: () => {
          setAanvraagID('')
        },
      },
    )
  }

  return (
    <Box sx={{ p: 1, width: '95%', mx: 'auto' }}>
      <Box>
        <FormControl>
          <TextField
            label="AanvraagID"
            value={aanvraagID}
            onChange={(ev) => setAanvraagID(ev.target.value)}
          />
        </FormControl>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Button variant="contained" onClick={onClick}>
          Resetten
        </Button>
      </Box>
      {!isLoading && (
        <Box sx={{ pt: 2 }}>
          <StyledError error={error} />
        </Box>
      )}
      {isLoading && (
        <LinearProgress
          sx={{
            mt: 2,
            height: '3px',
            backgroundColor: 'rgb(238, 238, 238)',
            background:
              'linear-gradient(to right, rgba(61, 108, 180, 1) 0%, rgba(79, 186, 219, 1) 100%)',
          }}
        />
      )}
    </Box>
  )
}
